export const STEP_SIZE = 12;
